import { useEffect, useState } from "react";
import { LOGO, NAV } from "@/data";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[var(--cream)]/85 backdrop-blur-md border-b border-black/5 py-3"
          : "py-5"
      }`}
    >
      <div className="mx-auto max-w-6xl px-6 flex items-center justify-between">
        <a href="#top" data-testid="logo-link" className="flex items-center">
          <img src={LOGO} alt="AGE Centrum" className="h-11 w-auto" />
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-${item.href.slice(1)}`}
              className="text-sm font-medium text-[var(--ink)]/70 hover:text-[var(--forest)] transition-colors duration-200"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <a
          href="#program"
          data-testid="header-program-cta"
          className="rounded-full bg-[var(--forest)] px-5 py-2.5 text-sm font-semibold text-white hover:bg-[var(--forest-dark)] transition-colors duration-200"
        >
          Program akce
        </a>
      </div>
    </header>
  );
};
